module.exports = __webpack_public_path__ + "static/media/pragprog.edb68faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/pragprog.jpg
// module id = 298
// module chunks = 0